<template>
  <div class="container_box">
    <!--面包屑导航-->
    <div class="breadcrumb_box">
      <Breadcrumb>
        <BreadcrumbItem v-for="(item, index) in breadcrumbList" :key="index" :to="item.path ? item.path : ''">{{ item.name }}</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <!--头部操作栏-->
    <div class="header_options_box">
      <div class="flex align-items-center">
        <span>{{ $t('key1004891') }}</span>
        <span class="font-weight-bold">{{ choicePackingWorkInfo.code }}</span>
        <span class="font-weight-bold ml10">{{ orderTypeObj[choicePackingWorkInfo.orderType] }}</span>
      </div>
      <div class="flex align-items-center">
        <span class="user_name">{{ $t('key1004892') + userName }}</span>
        <Button size="small" class="ml30" v-if="getPermission('ymsPickingOrder_endPackingForThirdPlatform')" @click="endJobBtn">{{ $t('key1004870') }}</Button>
      </div>
    </div>
    <!--SKU/货品身份码-->
    <div class="skuInput_box">
      <span>{{ $t('key1004821') }}</span>
      <Input
        v-model.trim="skuInput"
        :element-id="'sortingSku'"
        style="width:300px;marginLeft:15px;"
        :disabled="disabledInput"
        @on-enter="skuStart()">
      </Input>
    </div>
    <!--包装进度条-->
    <div class="packProcess_box">
      <Steps :current="packageProcessStep">
        <Step :title="$t('key1004883')" icon="ios-person"></Step>
        <Step :title="$t('key1004885')" icon="ios-person"></Step>
        <Step :title="$t('key1004886')" icon="ios-person"></Step>
        <Step :title="$t('key1004929')" icon="ios-person"></Step>
      </Steps>
    </div>
    <!--自动匹配包裹-->
    <div class="match_package_box">
      <div class="flex align-items-center">
        <div class="flex align-items-center">
          <span>{{ $t('key1004930') }}</span>
          <span>{{ tabsName }}</span>
        </div>
        <div class="flex align-items-center ml30">
          <span>{{ $t('key1004894') }}</span>
          <span>{{ packageCode }}</span>
        </div>
        <div class="flex align-items-center ml30" v-if="currentPackageData.length >0">
          <span>{{ $t('key1004931') }}</span>
          <span>{{ goodsTotalQuantity }}</span>
        </div>
      </div>
      <div class="flex align-items-center">
        <Button size="small" v-if="currentPackageData.length>0 &&
        getPermission('ymsThirdPlatformPackage_endPacking')" @click="packetBagBtn">{{ $t('key1004758') }}</Button>
        <Button class="ml15" size="small" @click="completeEntireOrderBtn">{{ $t('key1004923') }}</Button>
      </div>
    </div>
    <!--已扫描的货品信息-->
    <div class="scanPackage_box">
      <!--sku列表-->
      <div class="sku_list_box">
        <Table
          highlight-row
          border
          :loading="tableLoading"
          height="400"
          :columns="currentPackageColumn"
          :data="currentPackageData">
        </Table>
        <div class="cleanScanLink">
          <span class="cursor" v-if="currentPackageData.length>0 && getPermission('ymsThirdPlatformPackageGoods_batchDelete')"
            @click="emptyScannedItemsBtn('all')">{{ $t('key1004895') }}</span>
        </div>
      </div>
      <!-- 货品信息 -->
      <div class="productInfo_box">
        <Tooltip placement="left" theme="light" :transfer="true" transfer-class-name="set_bigimg_style">
          <img class="img_styles" :src="setImgPath(productImg)" @error="setErrorImg($event)" alt=""/>
          <template #content>
            <img :ref="'thumbnailImg'" @load="handlerOnloadImg('thumbnailImg')"
              :src="setImgPath(productImg)" @error="setErrorImg($event)" alt=""/>
          </template>
        </Tooltip>
        <p class="flex align-items-center mt15">
          <span class="title_styles">SKU：</span>
          <span class="text_styles">{{ sku }}</span>
        </p>
        <p class="flex align-items-center mt15">
          <span class="title_styles">{{ $t('key1002424') }}</span>
          <span class="text_styles">{{ title }}</span>
        </p>
      </div>
    </div>
    <!--拣货单内SKU-->
    <div class="match_package_box mt15 mb20">
      <h2 class="font-weight-bold">{{ $t('key1004932') }}</h2>
    </div>
    <Tabs type="card" v-model="tabsName" @on-click="changeTab" :animated="false">
      <TabPane v-for="(item,index) in tabList" :key="index" :label="(h)=>handleLabel(h,item)" :name="item.packageCode" :disabled="item.disabled">
        <Table
          class="table_box"
          highlight-row
          border
          :loading="tableLoading"
          height="400"
          :columns="printedPackageColumn"
          :data="printedPackageData">
        </Table>
      </TabPane>
    </Tabs>
    <!--货品数量异常提示-->
    <abnormalQuantityModal ref="abnormalQuantity" @completeBtn="completeBtn"></abnormalQuantityModal>
    <!--小包结袋弹窗-->
    <smallknotBagModal ref="smallknotBag" @smallknotBagBtn="smallknotBagBtn"></smallknotBagModal>
    <!--订单取消提示-->
    <orderCancelPromptModal ref="orderCancelPrompt" @updateData="updateDeliveryData"></orderCancelPromptModal>
    <!--商品标签选择-->
    <Modal v-model="platformItemSkuLabelPathModal" :title="$t('key1004816')" :mask-closable="false"
      @on-visible-change="platformItemSkuLabelPathChange">
      <div class="flex align-items-center">
        <span>{{ $t('key1004834') }}</span>
        <Select v-model="platformItemSku" filterable style="width: 200px;">
          <Option v-for="item in ymsPackageGoodsDetailsList" :value="item.platformItemSku" :key="item.platformItemSku">{{ item.platformItemSku }}</Option>
        </Select>
      </div>
      <template #footer>
        <div style="text-align: center;">
          <Button type="primary" @click="platformItemSkuLabelPathBtn" :disabled="!platformItemSku">{{ $t('key1000320') }}</Button>
          <Button @click="platformItemSkuLabelPathModal=false">{{ $t('key1000112') }}</Button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import smallknotBagModal from "@/views/yms/components/wms/exWarehouse/smallknotBagModal";
import abnormalQuantityModal from "@/views/yms/components/wms/exWarehouse/abnormalQuantityModal";
import orderCancelPromptModal from "@/components/common/orderCancelPromptModal.vue";
import {downloadControl, getUserNameByUserId, ymsVerifyPicking, qs, getAllUsersInfo, printHtmlUrl} from "@/utils/common";

export default {
  name: "choicePackingWork",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      breadcrumbList: [
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004788')},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004789')},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002654'), path: '/wms/packWorking'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004796')}
      ],
      skuInput: '',
      packageProcessStep: 0,
      packageCode: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004872'),
      goodsTotalQuantity: 0,
      originalCurrentPackageData: [],
      currentPackageData: [],
      currentPackageColumn: [
        {
          title: 'NO',
          width: 60,
          align: 'center',
          key: 'index',
          fixed: 'left',
          type: 'index',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004907'),
          key: 'title',
          align: 'center',
          render: (h, params) => {
            let title = params.row.title;
            let productGoodsSpecifications = params.row.productGoodsSpecifications;
            return h('div', [
              h('p', {
                attrs: {
                  title: title
                },
                class: 'text-over-line3 mb5 mt5 color-666'
              }, title),
              h('p', {
                class: 'color-green mb5'
              }, productGoodsSpecifications)
            ]);
          }
        },
        {
          title: 'SKU',
          key: 'ymsSku',
          align: 'center',
          render: (h, params) => {
            return h('span', {
              style: {
                color: '#008000'
              }
            }, params.row.ymsSku);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004835'),
          key: 'scanQuantity',
          align: 'center',
          render: (h, params) => {
            let scanQuantity = params.row.scanQuantity;
            return h('div', [
              h('InputNumber', {
                props: {
                  min: 1,
                  max: 99999999,
                  value: params.row.scanQuantity,
                  formatter: (value) => parseInt(value),
                  disabled: !v.getPermission('ymsThirdPlatformPackageGoods_manualUpdatedPackageSku'),
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  input: value => {
                    v.modifyQuantity = value;
                  },
                  'on-blur': () => {
                    if (v.modifyQuantity !== '' && v.modifyQuantity > 0) {
                      v.manuallyModifyQuantity(params.row, params.index);
                    } else {
                      v.$Modal.warning({
                        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004908'),
                        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000316'),
                        onOk: () => {
                          v.currentPackageData = [];
                          setTimeout(() => {
                            v.currentPackageData = JSON.parse(JSON.stringify(v.originalCurrentPackageData));
                          }, 100);
                        }
                      });
                    }
                  }
                }
              })
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
          key: 'operation',
          align: 'center',
          render: (h, params) => {
            return v.getPermission('ymsThirdPlatformPackageGoods_deleteSingle') ? h('Icon', {
              props: {
                type: 'md-close'
              },
              style: {
                margin: '0 10px',
                cursor: 'pointer',
                color: 'red'
              },
              on: {
                click: () => {
                  v.emptyScannedItemsBtn('single', params.row);
                }
              }
            }) : '';
          }
        }
      ],
      productImg: null, // 当前货品的图片
      sku: '',
      title: '',
      printedPackageData: [],
      printedPackageColumn: [
        {
          title: 'NO.',
          width: 80,
          align: 'center',
          key: 'index',
          type: 'index'
        },
        {
          title: 'SKU',
          key: 'ymsSku',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004909'),
          key: 'isPrinted',
          align: 'center',
          renderHeader: (h, params) => {
            return h('div', {class: 'flex flex-center-center'}, [
              h('span', {
                style: {
                  color: '#378000',
                  marginRight: '2px'
                }
              }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004910')),
              h('span', '/'),
              h('span', {
                style: {
                  color: '#ff0000',
                  marginLeft: '2px'
                }
              }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004911')),
            ]);
          },
          render: (h, params) => {
            let total = params.row.quantity || 0; // 总数数量
            let scanQuantity = params.row.scanQuantity || 0; // 已扫数量
            let unsweptQuantity = total - scanQuantity;
            return h('div', {class: 'flex justify-content-center align-items-center'}, [
              h('span', {
                style: {
                  color: '#378000',
                  marginRight: '2px'
                }
              }, scanQuantity),
              h('span', ' / '),
              h('span', {
                style: {
                  color: '#ff0000',
                  marginLeft: '2px'
                }
              }, unsweptQuantity),
            ]);
          },
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          align: 'center',
          width: 160,
          render(h, params) {
            let ymsPackageGoodsDetails = params.row.ymsPackageGoodsDetails || [];
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004912'),
                    show: true,
                    clickFn: () => {
                      if (ymsPackageGoodsDetails.length === 1) {
                        if (ymsPackageGoodsDetails[0].ymsThirdPlatformProductLabel) {
                          let labelPath = ymsPackageGoodsDetails[0].ymsThirdPlatformProductLabel.labelPath || null;
                          v.print(labelPath, params.row.ymsSku, true);
                        } else {
                          v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004149'));
                          return false;
                        }
                      } else {
                        v.ymsPackageGoodsDetailsList = ymsPackageGoodsDetails;
                        v.platformItemSkuLabelPathModal = true;
                      }
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      choicePackingWorkInfo: {},
      clearTime: null,
      ymsThirdPlatformPackageId: null,
      orderTypeObj: {
        TEMU_S: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004791'),
        TEMU_P: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004792')
      },
      disabledInput: false,
      packagedData: [], // 获取小包中已经完成结袋的数据
      modifyQuantity: 0,
      tabsName: null,
      tabList: [],
      handleLabel: (h, params) => {
        let packageCode = params.packageCode;
        let pickingBasketNo = params.pickingBasketNo;
        let verifyScanStatus = params.verifyScanStatus;
        let colorObj = {
          'partialPackaging': {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004913'), color: '#F59B1E'},
          'packaged': {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004914'), color: '#3CB034'},
          'completed': {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004915'), color: '#71B700'}
        };
        return h('div', {class: 'flex flex-direction justify-content-center align-items-center'}, [
          h('div', {class: 'flex align-items-center'}, [
            h('p', pickingBasketNo),
            h('p', {
              style: {
                color: verifyScanStatus && colorObj[verifyScanStatus].color ? colorObj[verifyScanStatus].color : ''
              }
            }, verifyScanStatus && colorObj[verifyScanStatus].title ? colorObj[verifyScanStatus].title : ''),
          ]),
          h('div', packageCode)
        ]);
      },
      ymsPackageId: null,
      ymsPackageGoodsDetailsList: [],
      platformItemSku: null,
      platformItemSkuLabelPathModal: false,
      userInfoList:{}
    };
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    // 当前操作人
    userName() {
      return getUserNameByUserId(this.userInfo.userId, this.userInfoList);
    }
  },
  created() {
    this.initData();
  },
  methods: {
    // 初始化接口数据
    initData() {
      let v = this;
      (async () => {
        await getAllUsersInfo().then((data) => {
          v.userInfoList = data;
        });
        await v.getchoicePackingWorkDetails();
      })();
    },
    // 拣货单取消提示
    hancelPrompt() {
      let v = this;
      setTimeout(() => {
        v.$Modal.info({
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004804'),
          content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004805'),
          okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000732'),
          onOk: () => {
            v.$router.push('/wms/packWorking');
          }
        });
      }, 1000);
    },
    // 获取拣货单详情数据
    getchoicePackingWorkDetails() {
      let v = this;
      let code = v.$route.query.code;
      clearTimeout(v.clearTime);
      v.axios.put(api.put_ymsPickingOrder_startPackingForThirdPlatform + '?code=' + code, null, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000672')}).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            setTimeout(() => {
              document.getElementById('sortingSku').focus();
            }, 2000);
            // 校验出库单中是否存在有已取消的订单(如果存在取消的订单则弹出取消订单提示窗)
            ymsVerifyPicking(api.put_ymsPickingOrder_checkPickingOrder, [data.ymsPickingOrderId]).then((list) => {
              if (list.length > 0) {
                this.$refs['orderCancelPrompt'].basicData = list;
                this.$refs['orderCancelPrompt'].orderCancelPromptModal = true;
              } else {
                v.choicePackingWorkInfo = data;
                v.handlePrintedPackageData(data);
              }
            });
          } else {
            v.hancelPrompt();
          }
        }
      });
    },
    // 处理拣货单的出库单数据
    handlePrintedPackageData(data) {
      let v = this;
      let ymsPickingOrderRelatedList = data.ymsPickingOrderRelatedList || [];

      // 按照packageCode进行分组 (Temu货品订单与常规分拣一样按照packageCode拣货进入拣货篮子)
      if (ymsPickingOrderRelatedList.length > 0) {
        let list = [];
        // 排除已移除云卖订单
        let effectivecloudSalesOrderList = ymsPickingOrderRelatedList.filter((item) => {
          return item.status === 1;
        });
        if (effectivecloudSalesOrderList.length > 0) {
          function handlePunctuationMark (str) {
            if (str) {
              return str.replace(/[:：,，]/g, (match) => {
                switch (match) {
                  case ":":
                  case "：":
                    return "：";
                  case ",":
                  case "，":
                    return "、";
                  default:
                    return match;
                }
              });
            }
          }
          effectivecloudSalesOrderList.map((item) => {
            if (item.ymsPackageInfo) {
              let ymsPackageGoodsList = item.ymsPackageInfo.ymsPackageGoods || [];
              if (ymsPackageGoodsList.length > 0) {
                ymsPackageGoodsList.map((ele) => {
                  ele['packageCode'] = item.packageCode;
                  ele['pickingBasketNo'] = item.pickingBasketNo;
                  ele['labelPath'] = null;
                  ele['scanQuantity'] = 0;
                  ele['productGoodsSpecifications'] = handlePunctuationMark(ele.variations);
                  ele['completedStatus'] = item.ymsPackageInfo.status === 5; // true 已完结    false 未完结
                  list.push(ele);
                });
              }
            }
          });
          if (list.length > 0) {
            let newList = v.handerGrouping(list, function (item) {
              return [item.packageCode];
            }, 'packageCode');
            if (newList.length > 0) {
              newList.map((item) => {
                item['ymsPackageId'] = item.data[0].ymsPackageId;
                item['pickingBasketNo'] = item.data[0].pickingBasketNo;
                item.data.map((ele) => {
                  ele['goodsLength'] = item.data.length;
                });
              });
              v.tabList = newList;
              // 判断当前是否有小包，如果没有小包默认选中第一个
              let ymsThirdPlatformPackages = data.ymsThirdPlatformPackages || [];
              if (ymsThirdPlatformPackages.length > 0) {
                v.handleSmallBagData(ymsThirdPlatformPackages, effectivecloudSalesOrderList);
              } else {
                v.selectPackage(v.tabList[0].packageCode);
              }
            }
          }
        } else {
          v.hancelPrompt();
        }
      } else {
        v.hancelPrompt();
      }
    },
    // 处理小包数据
    handleSmallBagData(ymsThirdPlatformPackages, ymsPickingOrderRelatedList) {
      let v = this;
      // 小包状态 1.已创建 2.包装中 3.包装完成
      v.currentPackageData = [];
      v.packagedData = [];
      // 包装完成--要将对应的扫描数量更新
      let packedList = ymsThirdPlatformPackages.filter((item) => {
        return item.status === 3 && item.ymsThirdPlatformPackageGoods && item.ymsThirdPlatformPackageGoods.length > 0;
      });
      console.log('---包装完成-------', packedList);
      if (packedList.length > 0) {
        let list = [];
        packedList.map((item) => {
          item.ymsThirdPlatformPackageGoods.map((ele) => {
            ele.ymsPackageId = item.ymsPackageId;
            list.push(ele);
          });
        });
        if (list.length > 0) {
          v.tabList.map((item, index) => {
            item.data.map((talg) => {
              list.map((ele) => {
                if (talg.ymsProductGoodsId === ele.ymsProductGoodsId && talg.ymsPackageId === ele.ymsPackageId) {
                  let scanQuantity = talg.scanQuantity + ele.quantity;
                  talg['scanQuantity'] = scanQuantity;
                  ele['title'] = talg.title;
                  ele['productGoodsSpecifications'] = talg.productGoodsSpecifications;
                  ele['ymsSku'] = talg.ymsSku;
                }
              });
            });
          });
          v.packagedData = list;
          v.forceRendering();
        }
      }
      // 包装中
      let newPackingList = ymsThirdPlatformPackages.filter((item) => {
        return item.status === 2 && item.ymsThirdPlatformPackageGoods && item.ymsThirdPlatformPackageGoods.length > 0;
      });
      if (newPackingList.length > 0) {
        ymsPickingOrderRelatedList.map((item) => {
          newPackingList.map((ele) => {
            if (item.ymsPackageId === ele.ymsPackageId) {
              v.selectPackage(item.packageCode);
            }
          });
        });
        v.ymsThirdPlatformPackageId = newPackingList[0].ymsThirdPlatformPackageId;
        v.packageCode = newPackingList[0].transferCode;
        let newList = newPackingList[0].ymsThirdPlatformPackageGoods;
        if (newList.length > 0) {
          newList.map((item) => {
            v.printedPackageData.map((ele) => {
              if (item.ymsProductGoodsId === ele.ymsProductGoodsId) {
                item.totalQuantity = ele.quantity;
                item.scanQuantity = item.quantity;
                ele.scanQuantity = item.quantity;
                item.labelPath = ele.labelPath;
                item['title'] = ele.title;
                item['productGoodsSpecifications'] = ele.productGoodsSpecifications;
                item['ymsSku'] = ele.ymsSku;
                if (item.scanQuantity !== 0 && item.totalQuantity === item.scanQuantity) {
                  v.packageProcessStep = 2;
                }
              }
            });
          });
          v.currentPackageData = newList;
          v.goodsTotalQuantity = v.currentPackageData.reduce(
            (pre, cur) => {
              return pre + cur.scanQuantity;
            }, 0);
        }
      }
      // 清空已扫描货品并重新扫描时，会将小包里面的货品信息全部清空，导致小包中没有货品信息，默认选中第一个
      else {
        v.selectPackage(v.tabList[0].packageCode);
      }
      v.verifyScanData();
    },
    // 选中对应的小包
    selectPackage(packageCode) {
      let v = this;
      v.tabList.map((item) => {
        if (item.packageCode === packageCode) {
          v.printedPackageData = item.data;
          v.tabsName = packageCode;
          v.ymsPackageId = item.data[0].ymsPackageId;
        }
      });
      this.verifyScanData();
    },
    // 切换Tab栏
    changeTab(name) {
      this.selectPackage(name);
    },
    // 移除已取消的出库单成功之后
    updateDeliveryData(obj) {
      let v = this;
      if (obj) {
        if (obj.allDelete === 1) {
          v.$Modal.info({
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004804'),
            content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004805'),
            okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000732'),
            onOk: () => {
              v.$router.push('/wms/packWorking');
            }
          });
        } else {
          v.getchoicePackingWorkDetails();
        }
      }
    },
    // 回车扫描sku
    skuStart() {
      let v = this;
      clearTimeout(v.clearTime);
      if (v.skuInput) {
        // 校验当前扫描sku是否在对应的出库单下
        let scanList = v.printedPackageData.filter((item) => {
          return item.ymsSku === v.skuInput;
        });
        if (scanList.length > 0) {
          // 先校验当前扫描的sku的扫描数量是否大于拣货单数量
          if (scanList[0].scanQuantity < scanList[0].quantity) {
            let query = {
              ymsPickingOrderId: v.choicePackingWorkInfo.ymsPickingOrderId,
              ymsSku: v.skuInput,
              ymsThirdPlatformPackageId: v.ymsThirdPlatformPackageId || null,
              ymsPackageId: v.ymsPackageId
            };
            v.disabledInput = true;
            if (v.getPermission('ymsThirdPlatformPackage_scanYmsSku')) {
              v.axios.post(api.post_ymsThirdPlatformPackage_scanYmsSku, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000672')}).then(response => {
                if (response.data.code === 0) {
                  let data = response.data.datas;
                  if (data) {
                    v.packageProcessStep = 1;
                    v.packageCode = data.transferCode;
                    v.ymsThirdPlatformPackageId = data.ymsThirdPlatformPackageId;
                    let matchThirdPlatformSkuBos = data.ymsThirdPlatformPackageGoodsResultBos;
                    if (matchThirdPlatformSkuBos && matchThirdPlatformSkuBos.length > 0) {
                      matchThirdPlatformSkuBos = v.uniqueFunc(matchThirdPlatformSkuBos, 'ymsProductGoodsId');
                      v.print(data.labelPath, v.packageCode, true);
                      matchThirdPlatformSkuBos.map((item) => {
                        v.printedPackageData.map((ele, idx) => {
                          if (item.ymsProductGoodsId === ele.ymsProductGoodsId) {
                            if (ele.ymsSku === v.skuInput) {
                              item.labelPath = ele.labelPath;
                              item.ymsSku = ele.ymsSku;
                              item.totalQuantity = ele.quantity;
                              item['productGoodsSpecifications'] = ele.productGoodsSpecifications;
                              item['pictureUrl'] = ele.pictureUrl;
                              let scanQuantity = ele.scanQuantity + 1;
                              // 判断当前扫描的sku是否有结袋过，如果有结袋过要把已经结袋的数量减掉
                              let quantityList = v.packagedData.filter((talg) => {
                                return talg.ymsSku === v.skuInput && v.ymsPackageId === talg.ymsPackageId;
                              });
                              if (quantityList.length > 0) {
                                let quantity = quantityList.reduce(
                                  (pre, cur) => {
                                    return pre + cur.quantity;
                                  }, 0);
                                let num = scanQuantity - quantity;
                                item.scanQuantity = num;
                              } else {
                                item.scanQuantity = scanQuantity;
                              }
                              v.$set(v.printedPackageData[idx], 'scanQuantity', scanQuantity);
                              v.packageProcessStep = 2;
                              v.productImg = ele.pictureUrl;
                              v.sku = item.ymsSku;
                              v.title = ele.title;
                            }
                          }
                        });
                      });
                      let list = matchThirdPlatformSkuBos.filter((item) => {
                        return item.ymsSku === v.skuInput;
                      });
                      let obj = list[0];
                      if (v.currentPackageData.length < 0) {
                        v.currentPackageData = matchThirdPlatformSkuBos;
                      } else {
                        let talg = v.currentPackageData.some((ele) => {
                          return ele.ymsSku === obj.ymsSku;
                        });
                        if (talg) {
                          v.currentPackageData.map((item, index) => {
                            if (item.ymsSku === obj.ymsSku) {
                              v.$set(v.currentPackageData[index], 'scanQuantity', obj.scanQuantity);
                            }
                          });
                        } else {
                          v.currentPackageData.push(obj);
                        }
                      }
                      v.currentPackageData = v.uniqueFunc(v.currentPackageData, 'ymsProductGoodsId');
                      // 记录当前小包中已扫数量的累加
                      v.goodsTotalQuantity = v.currentPackageData.reduce(
                        (pre, cur) => {
                          return pre + cur.scanQuantity;
                        }, 0);
                      v.forceRendering();
                      v.skuInput = '';
                      v.originalCurrentPackageData = JSON.parse(JSON.stringify(v.currentPackageData));
                    }
                  }
                } else {
                  v.disabledInput = false;
                }
              });
            } else {
              v.gotoError();
            }
          } else {
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004916'));
            return false;
          }
        } else {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004917'));
          return false;
        }
      } else {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004918'));
        return false;
      }
    },
    // 结束作业--需所有出库单都进行标记完结后才允许结束作业
    endJobBtn() {
      let v = this;
      let completedTalg = v.tabList.every((item) => {
        return item.verifyScanStatus === 'completed';
      });
      if (completedTalg) {
        let query = {
          ymsPickingOrderId: v.choicePackingWorkInfo.ymsPickingOrderId,
          flag: 0, // 0 否   1 是强制结束
        };
        v.axios.post(api.post_ymsPickingOrder_endPackingForThirdPlatform, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000672')}).then(response => {
          if (response.data.code === 0) {
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
            v.$refs['abnormalQuantity'].abnormalQuantityModal = false;
            setTimeout(() => {
              v.$router.push('/wms/packWorking');
            }, 800);
          }
        });
      } else {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004919'));
        return false;
      }
    },
    // 小包结袋
    packetBagBtn() {
      this.$refs['smallknotBag'].initSmallknotBagData(this.currentPackageData, this.ymsThirdPlatformPackageId);
    },
    // 小包结袋成功之后，更新数据
    smallknotBagBtn(data) {
      let v = this;
      v.currentPackageData = [];
      if (v.printedPackageData.length > 0) {
        let newList = [];
        v.tabList.map((item) => {
          newList.push(...item.data);
        });
        let talg = newList.every((item) => {
          return item.quantity === item.scanQuantity;
        });
        v.print(data, v.packageCode, true);
        if (talg) {
          v.resetPackageParam();
          v.packageCode = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004920');
        } else {
          v.resetPackageParam();
          v.getchoicePackingWorkDetails();
        }
        setTimeout(() => {
          document.getElementById('sortingSku').focus();
        }, 1500);
      }
    },
    // 清空已扫描货品并重新扫描
    emptyScannedItemsBtn(type, data) {
      let v = this;
      if (type === 'all') {
        clearTimeout(v.clearTime);
        let ymsThirdPlatformPackageGoodsIds = v.currentPackageData.map((item) => {
          return item.ymsThirdPlatformPackageGoodsId;
        });
        if (ymsThirdPlatformPackageGoodsIds.length > 0) {
          let query = {
            ymsThirdPlatformPackageGoodsIds: ymsThirdPlatformPackageGoodsIds,
            ymsThirdPlatformPackageId: v.ymsThirdPlatformPackageId
          };
          v.axios.post(api.post_ymsThirdPlatformPackageGoods_batchDelete, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000672')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
              v.currentPackageData = [];
              v.disabledInput = false;
              setTimeout(() => {
                v.resetPackageParam();
                v.getchoicePackingWorkDetails();
                v.$nextTick(() => {
                  document.getElementById('sortingSku').focus();
                });
              }, 1000);
            }
          });
        }
      } else {
        let query = {
          ymsThirdPlatformPackageGoodsId: data.ymsThirdPlatformPackageGoodsId,
          ymsThirdPlatformPackageId: v.ymsThirdPlatformPackageId
        };
        v.axios.post(api.post_ymsThirdPlatformPackageGoods_deleteSingle, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000672')}).then(response => {
          if (response.data.code === 0) {
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
            v.currentPackageData.map((item, index) => {
              if (item.ymsSku === data.ymsSku) {
                v.currentPackageData.splice(index, 1);
              }
            });
            v.printedPackageData.map((ele, idx) => {
              if (ele.ymsSku === data.ymsSku) {
                v.$set(v.printedPackageData[idx], 'scanQuantity', 0);
              }
            });
            // 记录当前小包中已扫数量的累加
            v.goodsTotalQuantity = v.currentPackageData.reduce(
              (pre, cur) => {
                return pre + cur.scanQuantity;
              }, 0);
            v.forceRendering();
          }
        });
      }
    },
    print(path, postId, flag, orderBy, callback) {
      let v = this;
      let originPostId = postId;
      postId = postId + parseInt(Math.random() * 100000000);
      if (path) {
        printHtmlUrl(path, postId).then(res => {
          if (res.printType === 'cainiao') {
            // 菜鸟打印完成
            v.finishPrint(callback);
            return;
          }
          let jsonObj = res;
          if (jsonObj.content) {
            jsonObj.content = encodeURIComponent(jsonObj.content);
          }
          let instance = v.axios.create({
            timeout: 3000,
            headers: {
              'Content-Type': 'multipart/form-data; charset=UTF-8'
            }
          });
          v.tableLoading = true;
          delete v.axios.defaults.headers.post['X-Requested-With'];
          instance.post('http://localhost:10099/print', qs(jsonObj)).then(response => {
            v.tableLoading = false;
            if (response.status === 200) {
              v.startPrintMonitor(jsonObj, originPostId, flag, orderBy, callback);
            }
          }).catch(() => {
            let fileName = '/tool/TongtoolPrinter.exe';
            downloadControl(fileName).then(() => {
              v.tableLoading = false;
            });
            v.disabledInput = false;
          });
        });
      } else {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004149'));
        v.tableLoading = false;
        v.disabledInput = false;
        v.$nextTick(() => {
          document.getElementById('sortingSku').focus();
        });
        return false;
      }
    },
    startPrintMonitor(jsonObj, postId, flag, orderBy, callback) {
      let v = this;
      let obj = {
        packageIds: [postId]
      };
      if (orderBy) {
        obj.printOrderBy = orderBy;
      }
      delete jsonObj.content;
      delete v.axios.defaults.headers.post['X-Requested-With'];
      v.axios.jsonp('http://localhost:10099/printResult?' + qs(jsonObj)).then(response => {
        console.log(typeof response.data);
        if (response.data === '0') {
          v.disabledInput = true;
          v.clearTime = setTimeout(function () {
            v.skuInput = null;
            v.startPrintMonitor(jsonObj, postId, flag, orderBy, callback);
          }, 1000);
        } else if (response.data === '2') {
          document.getElementById('sortingSku').focus();
          v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004806'));
          v.disabledInput = false;
          clearTimeout(v.clearTime);
        } else if (flag) {
          clearTimeout(v.clearTime);
          v.disabledInput = false;
          v.finishPrint(callback);
        }
      });
    },
    finishPrint(callback) {
      let v = this;
      v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
      v.packageProcessStep = 3;
      v.disabledInput = false;
      setTimeout(() => {
        v.packageProcessStep = 0;
        document.getElementById('sortingSku').focus();
      }, 1500);

    },
    resetPackageParam() {
      let v = this;
      v.packageProcessStep = 0;
      v.goodsTotalQuantity = 0;
      v.ymsThirdPlatformPackageId = null;
      v.packageCode = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004872');
    },
    // 手动修改扫描的小包中sku数量
    manuallyModifyQuantity(obj, currentIndex) {
      let v = this;
      // 先要校验当前修改的数量不能大于拣货单数量
      let totalQuantity = 0;
      let quantity = 0;
      let quantityList = v.packagedData.filter((talg) => {
        return talg.ymsSku === obj.ymsSku && v.ymsPackageId === talg.ymsPackageId;
      });
      if (quantityList.length > 0) {
        quantity = quantityList.reduce(
          (pre, cur) => {
            return pre + cur.quantity;
          }, 0);
        totalQuantity = obj.totalQuantity - quantity;
      } else {
        totalQuantity = obj.totalQuantity;
      }
      if (v.modifyQuantity <= totalQuantity) {
        let query = {
          quantity: v.modifyQuantity,
          ymsPickingOrderId: v.choicePackingWorkInfo.ymsPickingOrderId,
          ymsThirdPlatformPackageGoodsId: obj.ymsThirdPlatformPackageGoodsId
        };
        v.axios.put(api.put_ymsThirdPlatformPackageGoods_manualUpdatedPackageSku, query,
          {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000672')}).then(response => {
          if (response.data.code === 0) {
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
            v.printedPackageData.map((ele) => {
              if (obj.ymsProductGoodsId === ele.ymsProductGoodsId) {
                ele.scanQuantity = v.modifyQuantity + quantity;
                v.packageProcessStep = 2;
                let ymsPackageGoodsDetails = obj.ymsPackageGoodsDetails || [];
                if (ymsPackageGoodsDetails.length === 1) {
                  if (ymsPackageGoodsDetails[0].ymsThirdPlatformProductLabel) {
                    let labelPath = ymsPackageGoodsDetails[0].ymsThirdPlatformProductLabel.labelPath || null;
                    v.print(labelPath, v.packageCode, true);
                  } else {
                    v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004149'));
                    return false;
                  }
                } else {
                  v.ymsPackageGoodsDetailsList = ymsPackageGoodsDetails;
                  v.platformItemSkuLabelPathModal = true;
                }
              }
            });
            v.goodsTotalQuantity = v.currentPackageData.reduce(
              (pre, cur) => {
                return pre + cur.scanQuantity;
              }, 0);
            v.$set(v.currentPackageData[currentIndex], 'scanQuantity', v.modifyQuantity);
            v.forceRendering();
            v.originalCurrentPackageData = JSON.parse(JSON.stringify(v.currentPackageData));
            setTimeout(() => {
              v.modifyQuantity = 0;
            }, 800);
          } else {
            v.modifyQuantity = 0;
          }
        });
      } else {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004921'));
        v.$set(v.currentPackageData[currentIndex], 'scanQuantity', obj.scanQuantity);
        v.modifyQuantity = 0;
        v.forceRendering();
      }
    },
    // 强制渲染更新列表数据
    forceRendering() {
      let v = this;
      setTimeout(() => {
        if (v.printedPackageData.length > 0) {
          v.printedPackageData = [...v.printedPackageData];
        }
        if (v.currentPackageData.length > 0) {
          v.currentPackageData = [...v.currentPackageData];
        }
      }, 1500);
      v.$forceUpdate();
    },
    // 校验当前出库单下的货品是否已经全部扫描完成
    verifyScanData() {
      let v = this;
      console.log('-----v.tabList---------', v.tabList);
      if (v.tabList.length > 0) {
        v.tabList.map((item) => {
          let talg = item.data.every((ele) => {
            return ele.completedStatus;
          });
          if (talg) {
            item.verifyScanStatus = 'completed'; // 已完结
          } else {
            let talg_1 = item.data.every((ele) => {
              return ele.quantity === ele.scanQuantity;
            });
            if (talg_1) {
              item.verifyScanStatus = 'packaged'; // 已包装
            } else {
              let talg_2 = item.data.some((ele) => {
                return ele.scanQuantity !== 0;
              });
              if (talg_2) {
                item.verifyScanStatus = 'partialPackaging'; // 部分包装
              } else {
                item.verifyScanStatus = ''; // 未包装
              }
            }
          }
        });
      }
    },
    // 整单完结
    completeEntireOrderBtn() {
      let v = this;
      if (v.currentPackageData.length <= 0) {
        if (v.printedPackageData.length > 0) {
          // 判断当前出库单是否已经标记完结
          let completed = v.printedPackageData.every((ele) => {
            return ele.completedStatus;
          });
          if (completed) {
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004922'));
            return false;
          }
          let completedTalg = v.printedPackageData.every((ele) => {
            return ele.quantity === ele.scanQuantity;
          });
          // 当前出库单下已经全部扫描货品
          if (completedTalg) {
            v.$Modal.confirm({
              title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004923'),
              content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004924'),
              okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004925'),
              cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
              onOk: () => {
                let query = {
                  packedYmsPackageIds: [v.printedPackageData[0].ymsPackageId],
                  unpackedYmsPackageIds: [],
                };
                v.markCompletion(query);
              },
              onCancel: () => {

              }
            });
          }
          // 当前出库单下都没有扫描货品
          let noScanningTalg = v.printedPackageData.every((item) => {
            return item.scanQuantity <= 0;
          });
          if (noScanningTalg) {
            v.$Modal.confirm({
              title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004926'),
              content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004927'),
              okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004925'),
              cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
              onOk: () => {
                let query = {
                  packedYmsPackageIds: [],
                  unpackedYmsPackageIds: [v.printedPackageData[0].ymsPackageId],
                };
                v.markCompletion(query);
              },
              onCancel: () => {

              }
            });
          }
          // 当前出库单下只扫描了部分货品
          // let partTalg = v.printedPackageData.some((ele) => {
          //   return ele.scanQuantity > 0 && ele.quantity !== ele.scanQuantity;
          // });

          let partTalg = !noScanningTalg && !noScanningTalg;
          if (partTalg) {
            let list = v.printedPackageData.filter((item) => {
              return item.quantity !== item.scanQuantity;
            });
            v.$refs['abnormalQuantity'].initAbnormalQuantityData(list);
          }
        }
      } else {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004928'));
        return false;
      }
    },
    // 强制标记完结
    completeBtn() {
      let query = {
        packedYmsPackageIds: [this.printedPackageData[0].ymsPackageId],
        unpackedYmsPackageIds: [this.printedPackageData[0].ymsPackageId],
      };
      this.markCompletion(query);
    },
    // 处理标记完结
    markCompletion(query) {
      let v = this;
      let obj = {
        ymsPickingOrderId: v.choicePackingWorkInfo.ymsPickingOrderId
      };
      let params = Object.assign({}, obj, query);
      v.axios.post(api.post_ymsPickingOrder_finishOrderExecuteCreate, params, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000672')}).then(async response => {
        if (response.data.code === 0) {
          v.$refs['abnormalQuantity'].abnormalQuantityModal = false;
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
          v.resetPackageParam();
          v.getchoicePackingWorkDetails();
        }
      });
    },
    // 监听弹窗
    platformItemSkuLabelPathChange(value) {
      if (!value) {
        this.platformItemSku = null;
        this.ymsPackageGoodsDetailsList = [];
      }
    },
    // 打印商品标签
    platformItemSkuLabelPathBtn() {
      let list = this.ymsPackageGoodsDetailsList.filter((item) => {
        return item.platformItemSku === this.platformItemSku;
      });
      if (list.length > 0) {
        let ymsThirdPlatformProductLabel = list[0].ymsThirdPlatformProductLabel;
        if (ymsThirdPlatformProductLabel) {
          let labelPath = ymsThirdPlatformProductLabel.labelPath || null;
          this.print(labelPath, this.platformItemSku, true);
        }
      } else {
        this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004149'));
        return false;
      }
    }
  },
  watch: {
    // 监听当前小包中是否有数据
    currentPackageData: {
      handler(data) {
        this.tabList.map((item) => {
          if (data.length > 0) {
            item.disabled = true;
            let ymsPackageId = item.data[0].ymsPackageId;
            if (ymsPackageId === this.ymsPackageId) {
              item.disabled = false;
            }
          } else {
            item.disabled = false;
          }
        });
        this.verifyScanData();
        this.$forceUpdate();
      },
      immediate: true,
      deep: true
    }
  },
  components: {
    orderCancelPromptModal,
    abnormalQuantityModal,
    smallknotBagModal,
  }
};
</script>

<style lang="less" scoped>
.container_box {
  background-color: #fff;
  padding: 0 10px 10px 10px;

  .breadcrumb_box {
    padding: 12px 0 12px 0;
  }

  .header_options_box {
    padding: 0 12px;
    display: flex;
    justify-content: space-between;
    background-color: #f79646;
    height: 40px;
    align-items: center;
    width: 100%;
    margin: 0 auto;
    font-size: 16px;

    .user_name {
      display: inline-block;
      color: #fff;
      font-size: 16px;
      font-weight: bold;
      margin-right: 30px;
    }
  }

  .skuInput_box {
    font-size: 18px;
    font-weight: bold;
    color: #fff;
    padding: 18px 10px;
    background-color: rgba(43, 120, 228, 1);
    margin: 15px 0;
  }

  .packProcess_box {
    width: 100%;
    margin: 15px 0;
    border: 1px solid #000;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;

    /deep/ .ivu-steps {
      height: 50px;
      width: 700px;
      margin: 10px auto;

      .ivu-steps-title {
        display: block;
      }

      .ivu-steps-custom .ivu-steps-title {
        margin-left: -20px;
      }

      .ivu-steps-item {
        overflow: initial
      }
    }
  }

  .match_package_box {
    width: 100%;
    padding: 15px;
    background-color: #2B78E4;
    font-size: 13px;
    color: #fff;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
  }

  .scanPackage_box {
    width: 100%;
    border: 1px solid #d7d7d7;
    background-color: #fcfbe1;
    box-sizing: border-box;
    padding: 10px;
    display: flex;

    .sku_list_box {
      width: 1250px;
      height: 457px;
      background-color: #fff;
      border: 1px solid #a4c5eb;
      padding: 20px 15px 15px 15px;

      .cleanScanLink {
        display: block;
        margin-top: 8px;
        color: #327EE9;
        width: 100%;
        display: flex;
        justify-content: flex-end;
        font-size: 12px;
        padding-right: 15px;
      }
    }

    .productInfo_box {
      width: 628px;
      flex: 1;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .img_styles {
        vertical-align: middle;
        width: auto;
        max-width: 277px;
        height: 171px;
        cursor: pointer;
        display: inline-block;
        margin-bottom: 50px;
      }

      .title_styles {
        font-size: 22px;
        color: #515A6E;
      }

      .text_styles {
        font-size: 22px;
        color: #008000;
      }
    }
  }

  /deep/ .sku_list_box .ivu-table .ivu-input-number-handler-wrap {
    display: none !important;
  }

  /deep/ .ivu-tabs {
    .ivu-tabs-nav-container {
      min-height: 32px !important;
      height: auto !important;

      .ivu-tabs-tab {
        min-height: 32px !important;
        height: auto !important;
        font-size: 12px;
      }
    }
  }
}
</style>